<template>
  <div class="home">
    <v-container grid-md > 
         <PageIntro v-if="appLogin === false"
              :body="'<p>As of August 26, 2025, all supporters must have a Celtic FC Digital Account to purchase and manage tickets online.</p><p>Sign-in or create a new free Digital Account below.</p>'" />
    </v-container>
    <v-container grid-md > 
        <v-layout style="display: flex; flex-wrap: wrap;">
           
          <v-flex d-flex class="login-box">
            
            <main>
            <PageIntro v-if="appLogin === false"
              :heading="'Welcome Back, Sign In to Your Digital Account</span>'"
              :body="'<p>Enter your email and password to access your account.</p>'" />
            
            <Login />

            
          </main>
          </v-flex>
          <v-flex d-flex class="home-box">
            <div>
            <!-- <PageIntro 
              :heading="'Don\'t have a digital membership yet?'"
              :body="'<p>Register now and become #PartOfThePride!</p>'+
              '<p>Here\'s some of what you get:</p>'+
              '<ul><li>Watch Pre & post-match news and highlights on {{configStrings.clubStreamingPlatformName}}.</li>'+
              '<li>Listen to live match commentary.</li>'+
              '<li>Exclusive UZ competitions and polls.</li>'+
              '<li>Personalise your digital experience with the Club.</li>'+
              '<li>Access to the Pride Rewards loyalty scheme</li>'+
              '<li>Manage your ticketing account</li></ul></p>'"/> -->
              <PageIntro 
              :heading="'Create a Digital Account'"
              :body="'<p>Register for FREE to buy and manage tickets, shop at the official Celtic FC Store and get exclusive news, updates and competitions.</p>'"/>
            <HomeRegister  />
          </div>
          </v-flex>
        </v-layout>
      </v-container>
      <FooterShout v-if="appLogin === false" :type="'register'"/>
  </div>
</template>

<script>
  import Login from '@/components/Login'
  import HomeRegister from '@/components/HomeRegister'
  import PageIntro from '@/components/PageIntro'
  import FooterShout from '@/components/FooterShout'

  export default {
    components: {
      Login,
      HomeRegister,
      PageIntro,
      FooterShout
    },
    data() {
      return {
        from: null,
        appLogin: false
      }
    },
    mounted () {
      // if they are coming from the app specific login URL adapt the page accordingly
      if(this.$router.currentRoute.name === 'app-login'){
        this.appLogin = true
      }
      
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            vm.from = from;
            console.log('before route enter')
            // TODO: Make sure we handle people referred from password reset with a message on sign in page 
        });
    },
    
    
  }
</script>
<style lang="scss" scoped>

.login-box {
  width: 100%;
  margin-bottom:40px;
  @media screen and (min-width: 700px){
    width: 50%;
    margin-bottom:10px;
  }
}

.home-box {
  width: 100%;
  @media screen and (min-width: 700px){
    width: 50%;
  }
}
.notification {
  text-align: center;
}

</style>
